export const iconFontAwesomeMoneyCreditCard = (
	<i className="fa-solid fa-credit-card"></i>
);
